(function () {
    "use strict";

    angular
        .module("app")
        .controller("KPIDataController", KPIDataController);

    function KPIDataController($scope, $rootScope, $filter, $http, $q, $modal, $location, WorkflowService, PrototypeService, SeasonService, BrandService, SharedData, PatternService, BriefService, UserService, toaster, UserPreferenceService) {

        $scope.vm.loading = false;
        $scope.storedParams = {};
        $scope.data = [];
        $scope.seasons = [];
        $scope.chart = [];
        $scope.vm.tableType = $scope.vm.tableData[0].element;
        $scope.widgetId = $scope.$parent.wid;
        $scope.noBrandAndSeasonSelected = false;

        $scope.init = function () {
            $scope.loadParamsThenData();

            $scope.$watch(function () { return SharedData.getRefreshTrigger(); },
                function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        var s = SharedData.getSeasonId();
                        var b = SharedData.getBrandId();
                        if (b > 0 && s > 0) {
                            if ($scope.vm.SeasonId !== s || $scope.vm.BrandId !== b) {
                                $scope.noBrandAndSeasonSelected = false;

                                if ($scope.vm.BrandId !== b) {
                                    $scope.vm.BrandId = b;
                                    $scope.getSeasons(b);
                                }
                                $scope.vm.SeasonId = s;

                                $scope.saveBrandSeasonWidgetParams();

                                $scope.loadData();
                            }
                        }
                    }
                });
        }

        $scope.vm.chart_options = {
            tooltipTemplate: function (label) {
                return label.label + ": " + label.value;
            },
            legendTemplate: "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<segments.length; i++){%><li><span class=\"<%=name.toLowerCase()%>-legend-icon\" style=\"background-color:<%=segments[i].fillColor%>\"></span><span class=\"<%=name.toLowerCase()%>-legend-text\"><%if(segments[i].label){%><%=segments[i].label%> (<%=segments[i].value%>) <%}%></span></li><%}%></ul>",
            animation: false,
            animationSteps: 30
        };

        $scope.vm.getPrototypeStatusData = function () {
            if (!$scope.vm.BrandId || !$scope.vm.SeasonId) {
                $scope.noBrandAndSeasonSelected = true;
                return;
            }

            PrototypeService.getPrototypeStatuses($scope.vm.BrandId, $scope.vm.SeasonId, $scope.vm.chkMyProjects, true).then(function (response) {
                if (response && response.length > 0) {
                    var prototypes = response;
                    var packagedData = {};
                    angular.forEach(prototypes, function (prototype) {
                        var status = prototype.StatusName;
                        if (packagedData[status]) {
                            packagedData[status]++;
                        } else {
                            packagedData[status] = 1;
                        }
                    });

                    var labels = [];
                    var data = [];

                    angular.forEach(packagedData, function (count, status) {
                        labels.push(status);
                        data.push(count);
                    });

                    $scope.pieChart(labels, data, ["Statuses"]);

                }
                else {
                    $scope.showWarning("No data was found for this brand and season.");
                    $scope.emptyPieChart();
                }

            },
                function (error, status) {
                    $scope.showError("There was an error while retrieving prototype data. Please contact system administrator");
                    $scope.emptyPieChart();
                });
        };

        $scope.vm.getPatternStatusData = function () {

            if (!$scope.vm.BrandId || !$scope.vm.SeasonId) {
                $scope.noBrandAndSeasonSelected = true;
                return;
            }

            PatternService.getPatternStatuses($scope.vm.BrandId, $scope.vm.SeasonId, $scope.vm.chkMyProjects).then(function (response) {
                if (response && response.length > 0) {
                    var patterns = response;
                    var packagedData = {};
                    angular.forEach(patterns, function (pattern) {
                        var status = pattern.StatusName;
                        if (packagedData[status]) {
                            packagedData[status]++;
                        } else {
                            packagedData[status] = 1;
                        }
                    });

                    var labels = [];
                    var data = [];
                    angular.forEach(packagedData, function (count, status) {
                        labels.push(status);
                        data.push(count);
                    });

                    $scope.pieChart(labels, data, ["Statuses"]);

                }
                else {
                    $scope.showWarning("No data was found for this brand and season.");
                    $scope.emptyPieChart();
                }

            },
                function (error, status) {
                    $scope.showError("There was an error while retrieving pattern data. Please contact system administrator");
                    $scope.emptyPieChart();
                });
        };

        $scope.vm.getBriefStatusData = function () {
            if (!$scope.vm.BrandId || !$scope.vm.SeasonId) {
                $scope.noBrandAndSeasonSelected = true;
                return;
            }

            $scope.vm.loading = true;
            BriefService.getBriefStatuses($scope.vm.BrandId, $scope.vm.SeasonId, $scope.vm.chkMyProjects, true).then(function (response) {
                if (response && response.length > 0) {

                    var briefs = response;
                    var packagedData = {};
                    angular.forEach(briefs, function (brief) {
                        var status = brief.StatusName;
                        if (packagedData[status]) {
                            packagedData[status]++;
                        } else {
                            packagedData[status] = 1;
                        }
                    });

                    var labels = [];
                    var data = [];

                    angular.forEach(packagedData, function (count, status) {
                        labels.push(status);
                        data.push(count);
                    });

                    $scope.pieChart(labels, data, ["Statuses"]);

                    $scope.vm.loading = false;
                }
                else {
                    $scope.showWarning("No data was found for this brand and season.");
                    $scope.emptyPieChart();
                    $scope.vm.loading = false;
                }

            },
                function (error, status) {
                    $scope.showError("There was an error while retrieving brief data. Please contact system administrator");
                    $scope.emptyPieChart();
                    $scope.vm.loading = false;
                });
        };

        $scope.vm.getPrototypeSpecLock = function () {

            if (!$scope.vm.BrandId || !$scope.vm.SeasonId) {
                $scope.noBrandAndSeasonSelected = true;
                return;
            }

            PrototypeService.getPrototypeSpecLock($scope.vm.BrandId, $scope.vm.SeasonId, $scope.vm.chkMyProjects, true).then(function (response) {
                if (response && response.length > 0) {
                    var prototypes = response;
                    var packagedData = {};
                    angular.forEach(prototypes, function (prototype) {
                        var specLock = prototype.SpecLock;
                        if (packagedData[specLock]) {
                            packagedData[specLock]++;
                        } else {
                            packagedData[specLock] = 1;
                        }
                    });

                    var labels = [];
                    var data = [];

                    angular.forEach(packagedData, function (count, specLock) {
                        labels.push(specLock);
                        data.push(count);
                    });

                    $scope.pieChart(labels, data, ["Statuses"]);

                }
                else {
                    $scope.showWarning("No data was found for this brand and season.");
                    $scope.emptyPieChart();
                }

            },
                function (error, status) {
                    $scope.showError("There was an error while retrieving prototype data. Please contact system administrator");
                    $scope.emptyPieChart();
                });
        };

        $scope.vm.getCostingComplete = function () {

            if (!$scope.vm.BrandId || !$scope.vm.SeasonId) {
                $scope.noBrandAndSeasonSelected = true;
                return;
            }

            PrototypeService.getCostingCompleteCounts($scope.vm.BrandId, $scope.vm.SeasonId, $scope.vm.chkMyProjects, true).then(
                function (response) {
                    if (response && response.length > 0) {
                        var labels = ["IP", "ISR", "LDM", "SM", "Prod", "Tot."];
                        var series = ["Projects"];
                        var individualCounts = [];
                        var data = [];

                        individualCounts.push(response[0].InitialPrototypeCompleteCount);
                        individualCounts.push(response[0].ISRCompleteCount);
                        individualCounts.push(response[0].LDMCompleteCount);
                        individualCounts.push(response[0].SMCompleteCount);
                        individualCounts.push(response[0].SMFinalCompleteCount);
                        individualCounts.push(response[0].TotalProjectCount);

                        data.push(individualCounts);

                        $scope.barChart(labels, data, series, true);

                    } else {
                        $scope.showWarning("No data was found for this brand and season.");
                        $scope.barChart([""], [0], ["costing"]);
                    }

                },
                function (error, status) {
                    $scope.showError("There was an error while retrieving costing data. Please contact system administrator");
                    $scope.barChart([""], [0], ["costing"]);
                });
        };

        $scope.vm.getPrototypeBuyReady = function () {
            if (!$scope.vm.BrandId || !$scope.vm.SeasonId) {
                $scope.noBrandAndSeasonSelected = true;
                return;
            }

            PrototypeService.getPrototypeBuyReadyCounts($scope.vm.BrandId, $scope.vm.SeasonId, $scope.vm.chkMyProjects, $scope.vm.chkOnlyNew, true).then(
                function (response) {
                    if (response) {
                        var labels = ["Buy-Ready", "Not Buy-Ready"];
                        var data = [response.BuyReadyCount, response.NotBuyReadyCount];

                        $scope.pieChart(labels, data, ["Statuses"]);

                    } else {
                        $scope.showWarning("No data was found for this brand and season.");
                        $scope.emptyPieChart();
                    }

                },
                function (error, status) {
                    $scope.showError(
                        "There was an error while retrieving prototype data. Please contact system administrator");
                    $scope.emptyPieChart();
                });
        };

        $scope.vm.getEventLogData = function() {

            if (!$scope.vm.StartDate) {
                $scope.vm.StartDate = moment().subtract(14, "days").format("MM/DD/YYYY");
            }

            if (!$scope.vm.EndDate) {
                $scope.vm.EndDate = moment().add(1, "days").format("MM/DD/YYYY");
            }

            var currentStartDate = $filter("date")($scope.vm.StartDate, "MM/dd/yyyy");
            var currentEndDate = $filter("date")($scope.vm.EndDate, "MM/dd/yyyy");
            var ignoreLoadingBar = true;

            WorkflowService
                .getWFEventLogs(currentStartDate, currentEndDate, ignoreLoadingBar)
                .then(function(response) {
                        $scope.hasEvents = response.hasEvents;
                        $scope.configuredEventsCount = numeral(response.configuredEventsCount).format('0,0');
                        $scope.data = response.events;
                    },
                    function(error, status) {
                        $scope.showError('There was an error while retrieving workflow data. Please contact system administrator');
                    });
        };

        $scope.vm.getLastViewedProjects = function () {
            UserService.getLastViewedProjects(true).then(function (response) {
                if (response && response.length > 0) {
                    $scope.data = response;
                } else {
                    $scope.showWarning("No data was found for this user.");
                }

            }, function (error, status) {
                $scope.showError(
                    "There was an error while retrieving the data. Please contact system administrator");
            });
        };

        $scope.chartClick = function (sliceOfPie) {
            //console.log(sliceOfPie[0].label + ': ' + sliceOfPie[0].value);
        };

        $scope.prefKey = function () {
            return "Dashboard.params." + $scope.vm.tableType + "." + $scope.widgetId;
        };

        $scope.saveWidgetParams = function (params) {
            var json = JSON.stringify(params);
            var compared = JSON.stringify($scope.storedParams);

            if (json !== compared) {
                UserPreferenceService.updateSingleUserPreference(0, $scope.prefKey(), json, true);
                $scope.storedParams = params;
            }
        };

        $scope.saveBrandSeasonWidgetParams = function () {
            if ($scope.vm.BrandId && $scope.vm.SeasonId) {
                var params = { brandId: $scope.vm.BrandId, seasonId: $scope.vm.SeasonId, filterUser: $scope.vm.chkMyProjects, onlyNew: $scope.vm.chkOnlyNew };
                $scope.saveWidgetParams(params);
            }
        }

        $scope.loadParamsThenData = function () {
            return UserPreferenceService.getUserPreferences($scope.prefKey()).then(function (prefResponse) {
                var params = {};

                if (prefResponse.length > 0) {
                    var pref = prefResponse[0];
                    params = JSON.parse(pref.PreferenceValue);
                }

                if (!params)
                    params = {};

                $scope.storedParams = params;

                SharedData.getUserDefaults().then(function (userBrandSeason) {
                    $scope.brands = userBrandSeason.brands;
                    $scope.seasons = userBrandSeason.seasons;

                    $scope.vm.BrandId = userBrandSeason.brandId;
                    if (params && params.brandId)
                        $scope.vm.BrandId = params.brandId;

                    $scope.vm.SeasonId = userBrandSeason.seasonId;
                    if (params && params.seasonId)
                        $scope.vm.SeasonId = params.seasonId;

                    $scope.vm.chkMyProjects = params && params.filterUser === true;

                    $scope.vm.chkOnlyNew = params && params.onlyNew === true;

                    var hasBrandAndSeason = $scope.vm.BrandId &&
                        $scope.vm.SeasonId &&
                        $scope.vm.BrandId > 0 &&
                        $scope.vm.SeasonId > 0;

                    $scope.noBrandAndSeasonSelected = !hasBrandAndSeason;

                    if (!$scope.vm.SeasonId || $scope.vm.SeasonId === 0)
                        $scope.setEmptySeasons();

                    if ($scope.requiresBrandSeason() && !hasBrandAndSeason)
                        return;

                    $scope.loadData();
                });

            });
        };

        $scope.requiresBrandSeason = function () {
            return $scope.vm.tableType !== "eventLog" && $scope.vm.tableType !== "lastViewedProjects";
        };

        $scope.loadData = function () {
            switch ($scope.vm.tableType) {
                case "eventLog":
                    $scope.vm.getEventLogData();
                    break;
                case "lastViewedProjects":
                    $scope.vm.getLastViewedProjects();
                    break;
                case "prototypeStatuses":
                    $scope.vm.getPrototypeStatusData();
                    break;
                case "patternStatuses":
                    $scope.vm.getPatternStatusData();
                    break;
                case "briefStatuses":
                    $scope.vm.getBriefStatusData();
                    break;
                case "specLock":
                    $scope.vm.getPrototypeSpecLock();
                    break;
                case "costingComplete":
                    $scope.vm.getCostingComplete();
                    break;
                case "buyReady":
                    $scope.vm.getPrototypeBuyReady();
                    break;
            }
        };

        $scope.getSeasons = function (brand) {
            if (brand) {
                SeasonService.getSeasonsByBrand(brand).then(function (response) {
                    if (response) {
                        $scope.seasons = response;
                        if ($filter("filter")($scope.seasons, function (value) { return value.SeasonId === $scope.vm.SeasonId; }).length === 0)
                            $scope.vm.SeasonId = null;
                        //console.log($scope.vm.SeasonId);
                        $scope.noBrandSelected = false;
                        $scope.saveBrandSeasonWidgetParams();
                    }
                });

            } else {
                $scope.setEmptySeasons();
            }
        };

        $scope.setEmptySeasons = function () {
            $scope.noBrandSelected = true;
        };

        $scope.vm.switchboardController = function (projLevelId, projId) {
            $location.path($scope.vm.projectUrl(projLevelId, projId));
        };

        $scope.vm.projectUrl = function (projLevelId, projId) {

            switch (projLevelId) {
                case 1:
                    return "/linePlan/" + projId;
                case 2:
                    return "/brief/" + projId;
                case 3:
                    return "/pattern/" + projId;
                case 4:
                    return "/colorway/" + projId;
            }

            return "";
        };

        $scope.checkSeason = function (seasonId) {
            if (seasonId && seasonId > 0) {
                $scope.noBrandAndSeasonSelected = false;
                $scope.saveBrandSeasonWidgetParams();
            }
        };

        $scope.vm.validateEventLogSeasonalDate = function (scope, currentIndex, dateField) {
            scope.eventLogForm.startdate.$setValidity("sDate", true);
            scope.eventLogForm.enddate.$setValidity("eDate", true);

            var startDate = moment(scope.vm.StartDate, "MM/dd/yyyy");
            var endDate = moment(scope.vm.EndDate, "MM/dd/yyyy");

            if (startDate.isValid() && endDate.isValid()) {
                if (startDate.isSameOrBefore(endDate)) {
                    scope.eventLogForm.startdate.$setValidity("sDate", true);
                    scope.eventLogForm.enddate.$setValidity("eDate", true);
                } else {
                    if (dateField == "s") {
                        scope.eventLogForm.startdate.$setValidity("sDate", false);
                    } else if (dateField == "e") {
                        scope.eventLogForm.enddate.$setValidity("eDate", false);
                    }
                }
            }
        };

        $scope.showWarning = function (msg) {
            $scope.showMessage("warning", "Alert!", msg);
        };

        $scope.showError = function (msg) {
            $scope.showMessage("error", "Error!", msg);
        };

        $scope.showMessage = function (type, title, msg) {
            toaster.pop({
                type: type,
                title: title,
                body: msg,
                timeout: 5000
            });
        };

        $scope.showChart = function (labels, data, series, type, scaleShowLabels) {
            if (scaleShowLabels !== true) scaleShowLabels = false;
            var chart = {
                labels: labels,
                data: data,
                series: series,
                class: type,
                scaleShowLabels: scaleShowLabels
            };

            $scope.chart = chart;
        };

        $scope.pieChart = function (labels, data, series, scaleShowLabels) {
            $scope.showChart(labels, data, series, "chart-pie", scaleShowLabels);
        }

        $scope.emptyPieChart = function () {
            $scope.pieChart([""], [0], [""]);
        };

        $scope.barChart = function (labels, data, series, scaleShowLabels) {
            $scope.showChart(labels, data, series, "chart-bar", scaleShowLabels);
        };

        $scope.init();
    }
})();
